<p-tabMenu [model]="settingsNavs" [activeItem]="activeItem"></p-tabMenu>
<router-outlet></router-outlet>